/*
 * Shared Sweeps — keeps entries badges in sync with the selected variant's price.
 *
 * snippets/shared-sweeps.liquid renders each badge with the product-level
 * multiplier in data-ss-multiplier (product metafields only). The entries count is
 * the only per-variant value, so on a price change we recompute it here using the
 * same formula as Liquid: floor(price / 100 * multiplier). Bonus entries are
 * product-level and stay as rendered.
 */
(function () {
  if (window.SharedSweeps) return;

  function formatEntries(entries) {
    return entries.toLocaleString('en-US');
  }

  /**
   * @param {ParentNode} root - Element whose badges should be updated.
   * @param {number} priceCents - New price in cents.
   * @param {{ skipCards?: boolean }} [options] - skipCards ignores badges inside
   *   <product-card> (e.g. recommendation cards within a PDP section).
   */
  function update(root, priceCents, options) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    const price = Number(priceCents);
    if (!Number.isFinite(price)) return;
    const skipCards = options && options.skipCards;

    root.querySelectorAll('.ss-banner-wrapper[data-ss-multiplier]').forEach((wrapper) => {
      if (skipCards && wrapper.closest('product-card')) return;

      const multiplier = parseFloat(wrapper.dataset.ssMultiplier);
      if (!Number.isFinite(multiplier)) return;

      const entries = Math.floor((price / 100) * multiplier);
      wrapper.querySelectorAll('[data-ss-entries]').forEach((el) => {
        el.textContent = formatEntries(entries);
      });
    });
  }

  window.SharedSweeps = { update };
})();
